import { Currency } from 'dinero.js'
import { PaymentDetailFragment } from 'generated/resources/graphql'

import { toCurrency } from 'modules/finance/lib/multicurrency'

import { Payment as DataTablePayment } from '../components/PaymentsDataTable/types'

const isCurrency = (currency: string): currency is Currency => {
  return currency.length === 3 && currency === currency.toUpperCase()
}

export const lastPaymentExecution = (payment: DataTablePayment) => {
  return payment.paymentExecutions[payment.paymentExecutions.length - 1]
}
export const lastPaymentExecutionfromPaymentDetail = (payment: PaymentDetailFragment) => {
  return payment.paymentExecutions[payment.paymentExecutions.length - 1]
}

export const formattedAmount = ({
  amountCents,
  currency,
  locale,
  emptyValue = '',
}: {
  amountCents?: number | null
  currency?: string | null
  locale: string
  emptyValue?: string
}): string => {
  const upperCaseCurrency = currency?.toUpperCase()
  if (amountCents == null || !upperCaseCurrency || !isCurrency(upperCaseCurrency)) {
    return emptyValue
  }
  return toCurrency({
    amount: Math.round(amountCents || 0),
    currency: upperCaseCurrency,
    locale,
  })
}
